// src/components/pages/Caixa/tabs/caixaTabPanel.jsx
import React, { useMemo } from 'react';

import moment from 'moment';
import 'moment/locale/pt-br';

// MUI + MRT
import { MaterialReactTable } from 'material-react-table';
import { Button, Box, Tooltip, IconButton } from '@mui/material';
import { Delete, Edit, Print } from '@mui/icons-material';

import { ThemeProvider } from '@mui/material/styles';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import { podeEditar, podeImprimir, podeIncluir, podeCancelar, podeCancelarItem } from '../../../../hooks/usePermisionMRT';

import formStyles from '../../../form/Form.module.css';

import TextArea from '../../../form/TextArea';
import Input from '../../../form/Input';
import InputNumber from '../../../form/InputNumber';
import Checkbox from '../../../form/Checkbox';
import Select from '../../../form/Select';
import DataList from '../../../form/DataList';

/* utils */
import { formatarNumero } from '../../../../utils/masks';

const LancamentosTabPanel = ({
    module,
    //parametros
    profile,
    mrt,
    theme,
    isError,
    isLoading,
    isRefetching,
}) => {
    const {
        //mrt
        rowCount,

        caixaLancamentos,
        optionsTipo,
        novoLancamento,
        optionsParceiro,
        Parceiro,
        optionsCentroCusto,
        centroCusto,
        optionsMotorista,
        optionsVTR,

        optionsForma,
        optionsConta,

        divMapaAbastecimento,
        mapaAbastecimento,
    } = module.state;
    const { change: onChange, focus: onFocus, blur: onBlur } = module.actions;

    const {
        columnFilterFns,
        setColumnFiltersMode,
        columnFilters,
        setColumnFilters,
        globalFilter,
        setGlobalFilter,
        sorting,
        setSorting,
        pagination,
        setPagination,
    } = mrt;

    const uiTab = profile?.uiTabs?.lancamentos;

    const columns = useMemo(
        () => [
            {
                id: 'lancamento',
                header: 'Lançamentos do caixa',
                columns: [
                    {
                        accessorKey: 'Pessoa.descricao',
                        header: 'Parceiro',
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'tipo',
                        header: 'Tipo',
                    },
                    {
                        accessorKey: 'pagamentoForma.descricao',
                        header: 'Forma',
                    },

                    {
                        accessorKey: 'Conta.descricao',
                        header: 'Conta',
                    },
                    {
                        accessorKey: 'valorOriginal',
                        header: 'Valor',
                        muiTableBodyCellProps: {
                            align: 'right',
                        },
                        accessorFn: (row) =>
                            row.valor === null
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.valorOriginal)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'historico',
                        header: 'Historico',
                    },
                    {
                        accessorFn: (row) => new Date(row.dataVencimento),
                        accessorKey: 'dataVencimento',
                        header: 'Vencimento',

                        filterVariant: 'date',
                        sortingFn: 'date',
                        columnFilterModeOptions: [
                            'fuzzy',
                            'equals',
                            'between',
                            'betweenInclusive',
                            'greaterThanOrEqualTo',
                            'lessThanOrEqualTo',
                        ],
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {},
                        }),
                        muiTableHeadCellFilterTextFieldProps: {
                            type: 'date',
                            InputLabelProps: {
                                shrink: true,
                            },
                            sx: {
                                minWidth: '200px',
                            },
                        },
                        Cell: ({ renderedCellValue, row }) => {
                            return (
                                <span>
                                    {row.original.dataVencimento
                                        ? moment.utc(row.original.dataVencimento).format('DD/MM/YYYY')
                                        : null}
                                </span>
                            );
                        },
                    },
                    {
                        accessorKey: 'pagamentoPrazo.descricao',
                        header: 'Prazo',
                    },
                    {
                        accessorKey: 'centroCusto.descricao',
                        header: 'Centro de Custo',
                    },
                ],
            },

            //column definitions...
        ],
        [] //getCommonEditTextFieldProps
    );

    return (
        <div>
            <div className={formStyles.preview_bandeira}>
                <h4>{uiTab?.labels?.grid}</h4>
            </div>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    //marginTop: "1rem",
                    flexWrap: 'wrap', // Permite que os itens quebrem a linha quando necessário
                    // justifyContent: "space-between", // Distribui os itens igualmente
                }}
            >
                <Select
                    name="novoLancamento.tipo"
                    title={`Escolha o tipo do lançamento`}
                    text="Tipo"
                    inputWidth="100px"
                    options={optionsTipo}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoLancamento.tipo}
                    isEnum={true}
                    notOptNull={true}
                />
                <DataList
                    text="Parceiro para o Lançamento"
                    name="Parceiro.descricao"
                    placeholder={`Pesquise o parceiro para o lançamento`}
                    inputWidth="350px"
                    filteredOptions={optionsParceiro}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={Parceiro?.descricao || ''}
                />
                <Select
                    name="novoLancamento.formaId"
                    title="Selecione a forma do pagamento ou recebimento"
                    text="Forma"
                    inputWidth="180px"
                    options={optionsForma}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoLancamento.formaId}
                    isEnum={false}
                    notOptNull={false}
                />
                <Select
                    name="novoLancamento.contaId"
                    title="Selecione a conta"
                    text="Conta"
                    inputWidth="180px"
                    options={optionsConta}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoLancamento.contaId}
                    isEnum={false}
                    notOptNull={false}
                />
                <DataList
                    text="Centro de Custo"
                    title="Escolha o centro de custo"
                    placeholder={'Digite para pesquisar'}
                    name="centroCusto.descricao"
                    inputWidth="150px"
                    filteredOptions={optionsCentroCusto}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={centroCusto?.descricao || ''}
                />
            </div>
            <div>
                <TextArea
                    text="Histórico"
                    type="text"
                    name="novoLancamento.historico"
                    placeholder="Digite aqui o histórico do lançamento"
                    title="Digite o histórico do lançamento"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoLancamento.historico || ''}
                    textAlign="left"
                    linhas="4"
                    colunas="120"
                />
            </div>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    //marginTop: "1rem",
                    flexWrap: 'wrap', // Permite que os itens quebrem a linha quando necessário
                    // justifyContent: "space-between", // Distribui os itens igualmente
                }}
            >
                {divMapaAbastecimento && (
                    <>
                        <Checkbox
                            title="Grava mapa de abastecimento"
                            text="Mapa"
                            name="mapaAbastecimento.mapa"
                            handleOnChange={onChange}
                            value={mapaAbastecimento.mapa}
                            checked={!!mapaAbastecimento.mapa}
                        />

                        <Select
                            name="mapaAbastecimento.pessoaId"
                            title="Selecione o motorista"
                            text="Motorista"
                            inputWidth="180px"
                            options={optionsMotorista}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={mapaAbastecimento.pessoaId}
                            isEnum={false}
                            notOptNull={true}
                            required={mapaAbastecimento.mapa === true ? true : false}
                        />

                        <Select
                            name="mapaAbastecimento.produtoId"
                            title="Selecione o veículo"
                            text="Veículo"
                            inputWidth="180px"
                            options={optionsVTR}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={mapaAbastecimento.produtoId}
                            isEnum={false}
                            notOptNull={true}
                            required={mapaAbastecimento.mapa === true ? true : false}
                        />
                        <Input
                            text="Km Anterior"
                            type="number"
                            name="mapaAbastecimento.kmAnterior"
                            placeholder="Km"
                            inputWidth="100px"
                            title="Km anterior"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={mapaAbastecimento.kmAnterior || ''}
                            textAlign="center"
                            readonly={true}
                        />
                        <Input
                            text="Km Atual"
                            type="number"
                            name="mapaAbastecimento.km"
                            placeholder="Km"
                            inputWidth="100px"
                            title="Digite o km no momento do abastecimento"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={mapaAbastecimento.km || ''}
                            textAlign="center"
                            readonly={false}
                            required={mapaAbastecimento.mapa === true ? true : false}
                        />
                        <InputNumber
                            text="Litros"
                            type="text"
                            name="mapaAbastecimento.litros"
                            placeholder="Litros"
                            inputWidth="150px"
                            title="digite a quantidade de litros no momento do abastecimento"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={mapaAbastecimento.litros ? formatarNumero(mapaAbastecimento.litros) : ''}
                            required={mapaAbastecimento.mapa === true ? true : false}
                        />
                        <InputNumber
                            text="Preço do litro"
                            type="text"
                            name="mapaAbastecimento.preco"
                            placeholder="Preço R$"
                            inputWidth="150px"
                            title="digite o valor do litro"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={mapaAbastecimento.preco ? formatarNumero(mapaAbastecimento.preco) : ''}
                            required={mapaAbastecimento.mapa === true ? true : false}
                        />
                    </>
                )}
                <InputNumber
                    text="Valor"
                    type="text"
                    name="novoLancamento.valorOriginal"
                    placeholder="Valor R$"
                    inputWidth="100px"
                    title="digite o valor do lançamento em R$ (reais)"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoLancamento.valorOriginal ? formatarNumero(novoLancamento.valorOriginal) : ''}
                />
                <Button
                    variant="contained"
                    color="inherit"
                    onClick={module.actions.limparLancamento}
                    style={{
                        marginLeft: '10px',
                        minWidth: '80px',
                        fontSize: '14px',
                        '@media (max-width: 600px)': {
                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                        },
                    }}
                >
                    Limpar
                </Button>
                <Button
                    variant="contained"
                    color={novoLancamento.funcao === 'cancelar' ? 'error' : 'info'}
                    onClick={module.actions.handleLancamentos}
                    disabled={!novoLancamento.formaId || !novoLancamento.contaId || !novoLancamento.valorOriginal}
                    style={{
                        marginLeft: '10px',
                        minWidth: '80px',
                        fontSize: '14px',
                        '@media (max-width: 600px)': {
                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                        },
                    }}
                >
                    {novoLancamento.funcao}
                </Button>
            </div>
            <div>
                <ThemeProvider theme={theme}>
                    <MaterialReactTable
                        displayColumnDefOptions={{
                            'mrt-row-actions': {
                                muiTableHeadCellProps: {
                                    align: 'center',
                                },
                                size: 100,
                            },
                            'mrt-row-numbers': {
                                enableColumnOrdering: true, //turn on some features that are usually off
                                enableResizing: true,
                                muiTableHeadCellProps: {
                                    sx: {
                                        fontSize: '1.2rem',
                                    },
                                },
                            },
                            'mrt-row-select': {
                                enableColumnActions: true,
                                enableHiding: true,
                                size: 50,
                            },
                        }}
                        enableColumnFilterModes
                        enableGlobalFilterModes
                        //enableColumnResizing
                        enableColumnOrdering
                        enableEditing
                        renderRowActions={({ row, table }) => {
                            return (
                                <Box sx={{ display: 'flex', gap: '1rem' }}>
                                    <Tooltip arrow placement="top" title="Editar">
                                        <span>
                                            {' '}
                                            <IconButton
                                                onClick={() => module.actions.handleLancamento(row.original, row.index, 'Editar')}
                                                disabled={!podeEditar()}
                                            >
                                                <Edit />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip arrow placement="bottom" title="Deletar">
                                        <span>
                                            <IconButton
                                                color="error"
                                                onClick={() =>
                                                    module.actions.handleLancamento(row.original, row.index, 'Deletar')
                                                }
                                                disabled={!podeCancelarItem()}
                                            >
                                                <Delete />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip arrow placement="right" title="Recibo">
                                        <span>
                                            <IconButton
                                                onClick={() => module.actions.imprimirRecibo(row.original)}
                                                disabled={!podeImprimir()}
                                            >
                                                <Print />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Box>
                            );
                        }}
                        columns={columns}
                        data={caixaLancamentos || []}
                        enableRowSelection
                        getRowId={(row) => row.uuid}
                        manualFiltering
                        manualPagination
                        manualSorting
                        muiToolbarAlertBannerProps={
                            isError
                                ? {
                                      color: 'error',
                                      children: 'Error loading data',
                                  }
                                : undefined
                        }
                        onColumnFiltersChange={setColumnFilters}
                        onColumnFilterFnsChange={setColumnFiltersMode}
                        onGlobalFilterChange={setGlobalFilter}
                        onPaginationChange={setPagination}
                        onSortingChange={setSorting}
                        rowCount={rowCount}
                        initialState={{
                            showColumnFilters: true,
                            density: 'compact',
                            //columnPinning: { left: ["mrt-row-select"] },
                        }}
                        state={{
                            columnFilterFns,
                            columnFilters,
                            globalFilter,
                            isLoading,
                            pagination,
                            showAlertBanner: isError,
                            showProgressBars: isRefetching,
                            sorting,
                        }}
                        //positionToolbarDropZone={"top"}
                        positionExpandColumn={'first'}
                        positionActionsColumn={'first'}
                        positionToolbarAlertBanner="bottom"
                        localization={MRT_Localization_PT_BR}
                    />
                </ThemeProvider>
            </div>
        </div>
    );
};
export default React.memo(LancamentosTabPanel);
